var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":`Site Url ${_vm.required ? '*' : ''}`,"message":_vm.hint}},[_c('b-input',{ref:"url",attrs:{"disabled":_vm.disabled || _vm.locked,"readonly":_vm.locked,"placeholder":"yourdomain.com"},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }